var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"type":"text","autocomplete":"off","dense":"","hide-details":"","rules":_vm.rules,"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"autofocus":_vm.autofocus},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }